var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "isso-thread" } }, [
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.content,
              expression: "content"
            }
          ],
          staticClass: "textarea",
          attrs: { placeholder: "Escribe un mensaje" },
          domProps: { value: _vm.content },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.content = $event.target.value
            }
          }
        })
      ]),
      _c("div", { staticClass: "column is-one-quarter button-isso" }, [
        _c(
          "button",
          {
            staticClass: "button is-illuminating-emerald",
            attrs: { type: "submit" },
            on: {
              click: function($event) {
                return _vm.submit_comment(
                  _vm.content,
                  _vm.name,
                  _vm.email,
                  _vm.website,
                  _vm.notification
                )
              }
            }
          },
          [_vm._v("\n        Enviar\n      ")]
        )
      ])
    ]),
    _vm.$route.name !== "StatusAccountDetail" &&
    this.$store.state.auth.packages &&
    this.$store.state.auth.packages.includes("envioSMS")
      ? _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.sms,
                expression: "sms"
              }
            ],
            staticClass: "is-checkradio",
            class: { "is-success": _vm.sms },
            attrs: { id: "sms", name: "sms", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.sms)
                ? _vm._i(_vm.sms, null) > -1
                : _vm.sms
            },
            on: {
              change: function($event) {
                var $$a = _vm.sms,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.sms = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.sms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.sms = $$c
                }
              }
            }
          }),
          _c("label", { attrs: { for: "sms" } }, [
            _vm._v("\n      Enviar SMS\n    ")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }